// ------------------------------------
// Constants
// ------------------------------------
export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'

// ------------------------------------
// Actions
// ------------------------------------
export const pushNotification = (message) => {
	return (dispatch, getState) => {
	    dispatch({
	      type: PUSH_NOTIFICATION,
	      payload: message
	    })
  	}
}

export const dismissNotification = () => {
	return (dispatch, getState) => {
	    dispatch({
	      type: REMOVE_NOTIFICATION
	    })
  	}
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PUSH_NOTIFICATION]: (state, action) => {
  	if(!state.current){
  		return {
  			...state,
  			current: action.payload
  		}
  	} else {
  		return { 
  			...state,
  			queue: [...state.queue, action.payload]
		}
  	}
  },
  [REMOVE_NOTIFICATION]: (state, action) => {
  	return {
  		...state,
  		current: state.queue.shift(),
  		queue: state.queue
  	}
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { current: null, queue: []}
export default function notificationReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/notifications.js